import { css } from 'lit';

export const a11yStyles = css`
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .icon-button-reset {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    color: inherit;
    font: inherit;
  }

  .icon-button-reset:focus-visible {
    outline: 2px solid #222222;
    outline-offset: 2px;
  }
`;
